import { render, staticRenderFns } from "./Annotators.vue?vue&type=template&id=1a93c5ba&scoped=true&"
import script from "./Annotators.vue?vue&type=script&lang=js&"
export * from "./Annotators.vue?vue&type=script&lang=js&"
import style0 from "./Annotators.vue?vue&type=style&index=0&id=1a93c5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93c5ba",
  null
  
)

export default component.exports